import React, { useState } from 'react'
import { Container, Row, Col, ButtonGroup, Button } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { set, get } from '../../../reducers/data'
import { MigrationContentSwitcher } from '../../../dsy-wrappers/dsy-migration-content-switcher'

import Clima from "../../../icons/icon/clima.png"
import Bespoke from "../../../icons/icon/new/Frigo_Bespoke.png"
import Frigo75 from "../../../icons/icon/new/Frigo_75.png"
import TV from "../../../icons/icon/new/TV_Pic.png"
import Asciugatrice from "../../../icons/icon/new/Asciugatrice.png"
import Lavatrice from "../../../icons/icon/new/Lavatrice.png"
import Fotovoltaico from "../../../icons/icon/new/Foto.png"
import FotoBatteria from "../../../icons/icon/new/final_foto_batteria.png"
import Induzione from "../../../icons/icon/new/Induzione.png"
import RisparmioBox from '../reusable/RisparmioBoxComponent'
import FotoVirtuale from "../../../icons/icon/new/FotoVoltaicoVirtuale.png"
import FotoPlug from "../../../icons/icon/new/FotoMuratura.png"
import BeneficiComponent from './BeneficiComponent'
import ProductBox from '../reusable/ProductBoxComponent'
import HorizontalButtonGroup from '../../ui/horizontal-btn-group/HorizontalButtonGroup'


const prodottiOnline = {
  "Frigorifero Combinato F1RST 75 AI":
  {
    id: "RB53DG706AB1EF",
    rate: "24 rate mensili da 61,80€",
    prezzo: "1.483,20€*",
    tan: "TAN 5.75% - TAEG 5.87%"
  },
  "Frigorifero Combinato EcoFlex AI": {
    id: "RB38C607AS9/EF",
    rate: "24 rate mensili da 43,99€",
    prezzo: "1.055,75€*",
    tan: "TAN 5.75% - TAEG 5.87%"
  },
   "Samsung TV FHD 32\" F6000F": {
    id: "UE32F6000FUXZT",
    rate: "18 rate mensili da 18,35€",
    prezzo: "330,30€*",
    tan: "TAN 6.75% - TAEG 6.91%"
  },
  "SAMSUNG TV Crystal UHD 4K 43\" U8000F": {
    id: "UE43DU8075UXZT",
    rate: "24 rate mensili da 17,04€",
    prezzo: "409,96€*",
    tan: "TAN 5.75% - TAEG 5.85%"
  },
  "SAMSUNG TV Crystal UHD 4K 55\" U8000F": {
    id: "UE55DU8075UXZT",
    rate: "24 rate mensili da 22,37€",
    prezzo: "536,88€*",
    tan: "TAN 5.75% - TAEG 5.85%"
  },
  "SAMSUNG TV Crystal UHD 4K 65\" U8000F": {
    id: "UE65DU8075UXZT",
    rate: "24 rate mensili da 27,70€",
    prezzo: "664,80€*",
    tan: "TAN 5.75% - TAEG 5.85%"
  },
   "SAMSUNG TV OLED 4K 77\" S85F": {
    id: "QE77S85FAEXZT",
    rate: "24 rate mensili da 91,64€",
    prezzo: "2.199,36€*",
    tan: "TAN 5.75% - TAEG 5.88%"
  },
  "Asciugatrice BESPOKE AI™ Quick Dry": {
    id: "DV90BB7445GES3",
    rate: "24 rate mensili da 36,62€",
    prezzo: "878,88€*",
    tan: "TAN 5.75% - TAEG 5.87%"
  },
  "Lavatrice AI Control Ecodosatore": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 26,92€",
    prezzo: "646,08€*",
    tan: "TAN 5.75% - TAEG 5.83%"
  },
  "Lavatrice Bespoke AI Laundry": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 43,68€",
    prezzo: "1.048,32€*",
    tan: "TAN 5.75% - TAEG 5.87%"
  },
  "Piano a Induzione Slim Fit 60cm": {
    id: "NZ64B7799KK",
    rate: "24 rate mensili da 36,22€",
    prezzo: "869,28€*",
    tan: "TAN 5.75% - TAEG 5.87%"
  },
  "Samsung Lavatrice Serie 6400D Ai Control EcoDosatore": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 26,92€",
    prezzo: "646,08€*",
    tan: "TAN 5.75% - TAEG 5.83%"
  }
}

const prodottiNegozi = {
  "Frigorifero Combinato F1RST 75 AI":
  {
    id: "RB53DG706AB1EF",
    rate: "24 rate mensili da 57,99€",
    prezzo: "1.391,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Frigorifero Combinato EcoFlex AI": {
    id: "RB38C607AS9/EF",
    rate: "24 rate mensili da 43,99€",
    prezzo: "1.055,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
   "Samsung TV FHD 32\" F6000F": {
    id: "UE32F6000FUXZT",
    rate: "24 rate mensili da 12,99€",
    prezzo: "311,76€*",
    tan: "TAN 7.50% - TAEG 7.71%"
  },
  "SAMSUNG TV Crystal UHD 4K 43\" U8000F": {
    id: "UE43DU8075UXZT",
    rate: "24 rate mensili da 15,99€",
    prezzo: "383,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "SAMSUNG TV Crystal UHD 4K 55\" U8000F": {
    id: "UE55DU8075UXZT",
    rate: "24 rate mensili da 17,99€",
    prezzo: "431,80€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "SAMSUNG TV Crystal UHD 4K 65\" U8000F": {
    id: "UE65DU8075UXZT",
    rate: "24 rate mensili da 25,99€",
    prezzo: "623,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
   "SAMSUNG TV OLED 4K 77\" S85F": {
    id: "QE77S85FAEXZT",
    rate: "24 rate mensili da 85,99€",
    prezzo: "2.063,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Asciugatrice BESPOKE AI™ Quick Dry": {
    id: "DV90BB7445GES3",
    rate: "24 rate mensili da 33,99€",
    prezzo: "815,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Lavatrice AI Control Ecodosatore": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 24,99€",
    prezzo: "599,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Lavatrice Bespoke AI Laundry": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 42,99€",
    prezzo: "1031,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Piano a Induzione Slim Fit 60cm": {
    id: "NZ64B7799KK",
    rate: "24 rate mensili da 33,99€",
    prezzo: "815,76€*",
    tan: "TAN 0% - TAEG 0%"
  },
  "Samsung Lavatrice Serie 6400D Ai Control EcoDosatore": {
    id: "WW11DB7B94GEU3",
    rate: "24 rate mensili da 29,99€",
    prezzo: "719,76€*",
    tan: "TAN 0% - TAEG 0%"
  }
}

function ProdottoChip({ name }) {
  const names = {
    "TV": "Televisore",
    "Fotovoltaico": "Fotovoltaico da tetto",
    "Clima": "Climatizzatore a pompa di calore"
  }
  return names[name] || name;
}

function Prodotto({ itemBase, key, index, selected, extraMessage }) {
  console.log("ITEM BASE", itemBase)
  const item = { ...itemBase }
  const data = useSelector(get)
  if (!item.modello || !item.scontato) {
    console.log("missing" + item)
    item.modello = ""
    return <div key={key}></div>
  }

  const isElettrodomestico = item.name === "Televisore" || item.name === "TV" || item.name === "Asciugatrice" ||
    item.name === "Frigo" || item.name === "Lavatrice"
  const images = {
    "Frigorifero Combinato EcoFlex AI": Bespoke,
    "Frigorifero Combinato F1RST 75 AI": Frigo75,
  }

  let rate = null
  let scontato = null
  let codice = item.modello.indexOf("Plug&Play") > -1 ? "Consegna bordo strada inclusa" : "Installazione inclusa"
  let tan = null

  const prodotti = data["negozi"] ? prodottiNegozi : prodottiOnline

  if (isElettrodomestico && prodotti[item.modello] === undefined) {
    if (item.scontato) {
      item.rate = "24 rate mensili da " + (item.scontato / 24).toFixed(2) + "€"
      item.prezzo = item.scontato + ",00€*"
      item.tan = data["negozi"] ? "TAN 0% - TAEG 0%" : "TAN 7.50% - TAEG 7.72%"
    }
    else {
      console.log("missing" , item)
      return <div key={key}></div>
    }
  }

  if (isElettrodomestico) {
    
    try {
      codice = prodotti[item.modello].id
      rate = prodotti[item.modello].rate
      scontato = prodotti[item.modello].prezzo
      tan = prodotti[item.modello].tan
    }
    catch (e) {
      console.log(prodotti, prodotti[item.modello])
      return <div key={key}>{<>{JSON.stringify(prodotti + "-->" + item.modello)}</>}</div>
    }
  }

  let img = images[item.modello]
  if (item.name === "Clima") img = Clima
  if (item.name === "Fotovoltaico") img = Fotovoltaico
  if (item.modello.includes("Batteria") || item.name.includes("Batteria")) img = FotoBatteria
  if (item.modello.includes("Plug")) img = FotoPlug
  if (item.name === "TV") img = TV
  if (item.name === "Asciugatrice") img = Asciugatrice
  if (item.name === "Lavatrice") img = Lavatrice
  if (item.name === "Induzione") img = Induzione

  return (
    <Col md={12} key={key}>
      <div className='product mt-3 elevation-shadow'>
        <div className='top d-flex mb-2 mb-lg-0 justify-content-between col-12 col-lg-6'>
          <div className="img-container">
            <img src={img} alt="" role="presentation" />
          </div>
          <div className="product-container" style={{ flexGrow: 1 }}>
            <span className='tag'>
              <ProdottoChip name={item.name} />
            </span>
            <div className='product-title'>
              {item.link && item.link.length > 1 ?
                <a target='_blank' rel='noreferrer'>{item.modello} </a>
                :
                <>{item.modello}</>
              }
            </div>
            <div className='d-flex justify-content-between light'>
              {codice && <div className='codice'>{codice}</div>}
              <div className='qty'>Quantità: {item.qty}</div>
            </div>
          </div>
        </div>
        <div className={"col-12 col-lg-6 d-flex bottom flex-column " + (extraMessage ? "justify-content-between" : "justify-content-center")}>
          <div className=' d-flex justify-content-between  align-items-center'>
            <div className='light'>
              <b>Totale</b> <br />
              (IVA inclusa)
            </div>
            <div className='price'>
              <div className='final'>{scontato ?? item.scontato + ",00€"}</div>
              <div className='sub'>
                {rate && <p className='f14 mb-0' style={{ color: "#272C34" }}>{rate}</p>}
                {tan && <p className='f14 mb-0 bold' style={{ color: "#272C34" }}>{tan}</p>}
                {tan && <p className="f12">Prodotto disponibile solo con <br /> finanziamento tramite finanziaria</p>}
                {/* <span className='green'>Ecobonus {item.ecobonus}&nbsp;</span> */}
                {/* <span className='striked'>{item.costo.replace(",", ".")}€</span> */}
              </div>
            </div>
          </div>
          {extraMessage && <div className='extra-message'>{extraMessage}</div>}
        </div>

      </div>
    </Col>
  )
}

function ProdottoFotoVirtuale({ itemBase, key, index, selected, extraMessage }) {

  return (
    <Col md={12} key={key}>
      <div className='product align-items-start'>
        <div className='top d-flex mb-2 mb-lg-0 justify-content-between col-12 col-lg-6'>
          <div className="img-container align-items-start">
            <img src={FotoVirtuale} alt="" role="presentation" />
          </div>
          <div className="product-container" style={{ flexGrow: 1 }}>
            <span className='tag'>
              <ProdottoChip name={"Offerta luce"} />
            </span>
            <div className='product-title'>
              Fotovoltaico Virtuale
            </div>
            <div className='d-flex justify-content-between light'>
              Energia solare/mese: 130kWh**
            </div>
          </div>
        </div>
        <div className={"col-12 col-lg-6 d-flex bottom flex-column "}>
          <div className=' d-flex justify-content-between  align-items-center'>
            <div className='light'>
              <b>Costo Iniziale</b> <br />
              (IVA inclusa)
            </div>
            <div className='price'>
              <div className='final'>99,00€</div>
              <div className='sub'> </div>
            </div>
          </div>
          <hr />
          <div className=' d-flex justify-content-between  align-items-center'>
            <div className='light'>
              <b>Componente energia</b> <br />
              (IVA inclusa)
            </div>
            <div className='price'>
              <span className="f18 bold">0,000€/kWh</span><span className="f12 bold">* dalle 10 alle 17</span>
              <div className="f14">fino a 130kWh/mese</div>
              <br />
              <span className="f18 bold">0,165€/kWh</span><span className="f12 bold">* dalle 10 alle 17</span>
              <div className="f14">e oltre alla soglia di 130kWh/mese</div>
            </div>
          </div>
          <hr />
          <div className=' d-flex justify-content-between  align-items-center'>
            <div className='light'>
              <b>Canone mensile</b> <br />
              (IVA inclusa)
            </div>
            <div className='price'>
              <div className='final'><span className="f18">12€</span> <span className="f14">/ POD al mese</span> </div>
              <div className='sub'> </div>
            </div>
          </div>
          <hr />
          <div className=' d-flex justify-content-between  align-items-center'>
            <div className='light'>
              <b>CCV</b> <br />
              (IVA inclusa)
            </div>
            <div className='price'>
              <div className='final'><span className="f18">10€</span><span className="f14"> / POD al mese</span> </div>
              <div className='sub'> </div>
            </div>
          </div>
        </div>

      </div>
    </Col>
  )
}


const txts = {
  "Clima": "Per migliorare il riscaldamento della tua casa ti suggeriamo di usare un climatizzatore a pompa di calore:",
  "ScaldAcqua": "Per migliorare la produzione di acqua calda della tua casa ti suggeriamo di usare uno scalda acqua a pompa di calore:",
  "Induzione": "Per migliorare la cottura cibi della tua casa ti suggeriamo di usare una piastra ad induzione:",
  "Fotovoltaico": "Per migliorare l'efficienza energetica della tua casa ti suggeriamo di usare un sistema di autoproduzione:"
}

function FinalHeaderComponent() {
  const data = useSelector(get)
  const totalProds = data.products
  const prodotti = data.products.reduce((acc, item) => {
    if (item.name === "TV" || item.name === "Asciugatrice" || item.name === "Frigo" || item.name === "Lavatrice") {
      if (acc["Elettrodomestici"]) {
        acc["Elettrodomestici"].push(item)
      }
      else {
        acc["Elettrodomestici"] = [item]
      }
    }
    else {
      if (acc[item.name]) {
        acc[item.name].push(item)
      } else {
        acc[item.name] = [item]
      }
    }
    return acc
  }, {})
  let startingCategory

  Object.keys(prodotti).forEach(key => {
    if (prodotti[key].length > 0) {
      if (startingCategory === undefined)
        startingCategory = key
      return
    }
  })
  if (data["ConsumoOrario"] === true) prodotti["Offerta luce"] = null
  const [selected, setSelected] = useState(startingCategory)
  const copy = txts[selected]
  const t = {
    "Clima": "Riscaldamento",
    "ScaldAcqua": "Acqua Calda",
  }

  // const buttons = [...Object.keys(prodotti), "Sintesi investimento"]
  //   .map(key => key.replace("Acqua", "acqua").replace("Clima", "Riscaldamento").replace("Induzione", "Cottura Cibi"))

  const buttons = [...Object.keys(prodotti), "Sintesi investimento"].reduce((acc, key) => {
    acc.push({
      label: key.replace("Acqua", "acqua").replace("Clima", "Riscaldamento").replace("Induzione", "Cottura Cibi"),
      value: key
    });
    return acc;
  }, []);

  return (
    <div className='header'>
      <Container fluid className='final-header mx-0'>
        <Row>
          <Col md={12} className='right-side'>
           

            <HorizontalButtonGroup
              buttons={buttons}
              defaultActive={selected}
              onButtonClick={setSelected}
              className="elevation-shadow"
            />

         
            {selected === "Sintesi investimento" ? <div className="recap-box elevation-shadow">
              <div className="bold f18">
                Riepilogo dell’investimento
              </div>
              {totalProds.map(x => <div className="d-flex justify-content-between">
                <div className="f14 lh30">{x.modello}</div>
                <div className="f20 lh30 bold">{x.scontato},00 €</div>
              </div>)}
            </div> :
              <Row className='prodotti'>
                {selected === "Offerta luce" && <Col>
                  <ProdottoFotoVirtuale
                    key={1231231}
                    index={123131}
                    selected={selected}
                  // extraMessage={"Paga il tuo acquisto in 10 comode rate mensili da 39€"}
                  />
                  {/* <RisparmioBox 
                title="Solare Virtuale"
                description="da 1.0kW"
                tag="Offerta luce"
                image={FotoVirtuale}
                attualeTitle={"Costo iniziale"}
                attualeDescription={"IVA inclusa"}
                attualeValue={"99,00€"}
                futuraTitle={"Abbonamento mensile"}
                futuraDescription={"IVA inclusa"}
                futuraValue={"12€ + CCV 10€/mese"}
             />  */}
                </Col>
                }

                {prodotti[selected]?.map((item, index) => (
                  <Prodotto
                    key={index}
                    itemBase={item}
                    index={index}
                    selected={selected}
                  // extraMessage={"Paga il tuo acquisto in 10 comode rate mensili da 39€"}
                  />
                ))}

              </Row>}
          </Col>
        </Row>
        <Row>
          <BeneficiComponent type={selected} />
        </Row>
      </Container>
    </div>
  )
}

export default FinalHeaderComponent
